// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"fa11bd54","453":"9118b419","665":"a23655c0"}[chunkId] + ".chunk.js";
};